import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

// MODELOS
import { AppConstants, CustomURLEncoder, IPermission, Perms, PermsUserEdit } from '../models';

// RUTAS

// COMPONENTES

// SERVICIOS
import { StorageService,  } from './storage.service';
import { AlertService } from './alert.service';
import { IResponse } from '../models/i-api-response';
import { Observable } from 'rxjs';
import {IPermissionsResponse} from "../models/responses";

// PIPES

@Injectable({
  providedIn: 'root'
})
export class PermsService {

  permsUserEdit: PermsUserEdit;

  @BlockUI() blockUI: NgBlockUI;
  constructor(private http: HttpClient, private storage: StorageService, private alertService: AlertService) {
    this.permsUserEdit = new PermsUserEdit();
    // console.log(0);
  }
// obtine la lista de usuarios
// no recive paramestros
  getUsers() {

    const token = JSON.parse(this.storage.getCurrentSession());
    const url = `${AppConstants.apiUrl}api/Perms/GetUserList`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token.access_token}`
    });

    return this.http.get( url, {headers});
  }
// obtiene la lista de permisos
// recive un numero que es el ID del usuario al que se le van a obtener los permisos
  getPerms(numId: any): Observable<IPermissionsResponse> {

    let num = encodeURIComponent(numId);
    const token = JSON.parse(this.storage.getCurrentSession());
    const url = `${AppConstants.apiUrl}api/Perms/GetPermsByUser/?user=${num}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token.access_token}`
    });
    return this.http.get<IPermissionsResponse>( url , {headers});
  }

  getPermsforMenu() {
    const token = JSON.parse(this.storage.getCurrentSession());
    const url = `${AppConstants.apiUrl}api/Perms/GetPermsByUserMenu`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token.access_token}`
    });
    return this.http.get( url , {headers});
  }

  // envia la informacion al api para guardar la informacion y los cambios sobre los permisos por usuario
  // parametros el model de permisos y el id de usuario
  savePermsChange(model: Perms[], user: number): any {
    const token = JSON.parse(this.storage.getCurrentSession());
    const url = `${AppConstants.apiUrl}api/Perms/EditPermsByUser`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token.access_token}`
    });

    this.permsUserEdit.UserPerms = model;
    this.permsUserEdit.UserId = user;
    // omologo del ajax de Jquery para enviar datos a consumir urls externas
    return this.http.post( url,
    this.permsUserEdit ,
    { headers });
  }

  AuthorizerUser(_email: string, password: string): Observable<IResponse<IPermission[]>> {

    const URL = `${AppConstants.apiUrl}api/Documents/CheckCreditNoteAuthorizations`;

    const body = new HttpParams({ encoder: new CustomURLEncoder() })
      .set('grant_type', 'password')
      .set('username', _email)
      .set('password', password)
      .set('is_login', 'true');

      const token = JSON.parse(this.storage.getCurrentSession());

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${token.access_token}`
    });

    return this.http.post<IResponse<IPermission[]>>(URL, body.toString(), { headers });
  }

  AuthorizerDeliveryUser(_email: string, password: string): Observable<IResponse<IPermission[]>> {

    const URL = `${AppConstants.apiUrl}api/Deliveries/CheckDeliveryAuthorizations`;

    const body = new HttpParams({ encoder: new CustomURLEncoder() })
      .set('grant_type', 'password')
      .set('username', _email)
      .set('password', password)
      .set('is_login', 'true');

    const token = JSON.parse(this.storage.getCurrentSession());

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${token.access_token}`
    });

    return this.http.post<IResponse<IPermission[]>>(URL, body.toString(), { headers });
  }

  /**
   * Valida el permiso para esitar el numero de orden de laboratorio
   * @param _email
   * @param password
   * @constructor
   */
  AuthDeliveryToEditLabOrderNum(_email: string, password: string): Observable<IResponse<IPermission[]>> {

    const URL = `${AppConstants.apiUrl}api/Deliveries/CheckDeliveryAuthToEditLabOrderNum`;

    const body = new HttpParams({ encoder: new CustomURLEncoder() })
      .set('grant_type', 'password')
      .set('username', _email)
      .set('password', password)
      .set('is_login', 'true');

    const token = JSON.parse(this.storage.getCurrentSession());

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${token.access_token}`
    });

    return this.http.post<IResponse<IPermission[]>>(URL, body.toString(), { headers });
  }

}
